<template>
  <tbody class="table-group-divider">
    <slot />
  </tbody>
</template>
